import React, { ChangeEvent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useAppDispatch, useAppSelector } from '../../App/Hooks/reduxHooks'
import { setUserSettings } from '../settings/userSettings'
import {
  calendarSettingsSelector,
  setColorContrast,
} from '../store/calendarSlice'

import {
  ContrastSliderText,
  ContrastSliderTextWrapper,
  ContrastSliderWrapper,
  SlidersLabels,
  ZoomSlider,
} from './style'

export const ContrastPicker = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const [userContrast, setContrastUserContrast] = useState<{
    color: string
    value: string
  }>({
    color: 'rgba(201,201,201, 0.8)',
    value: '10',
  })

  const calendarSettings = useAppSelector(calendarSettingsSelector)
  const colorContrast = calendarSettings.colorContrast
  const colorContrastValue = calendarSettings.colorContrastValue

  useEffect(() => {
    if (colorContrast && colorContrastValue) {
      setContrastUserContrast({
        color: colorContrast,
        value: colorContrastValue,
      })
    }
  }, [colorContrastValue, colorContrast])

  const onColorChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    const valueToNumber = parseInt(value, 10)

    const fixedValue = 201

    const sum = fixedValue - valueToNumber

    const sumToString = sum.toString()

    const color = `rgba(${sumToString}, ${sumToString}, ${sumToString}, 0.8)`

    setContrastUserContrast({
      color,
      value,
    })
  }

  const onColorSet = () => {
    setUserSettings({
      colorContrast: userContrast.color,
      colorContrastValue: userContrast.value,
    })
    dispatch(
      setColorContrast({
        colorContrast: userContrast.color,
        colorContrastValue: userContrast.value,
      }),
    )
  }

  return (
    <ContrastSliderWrapper>
      <SlidersLabels>
        <ZoomSlider
          value={userContrast.value}
          type="range"
          min="10"
          max="100"
          step="10"
          onChange={e => {
            onColorChange(e)
          }}
          onMouseUp={onColorSet}
        />
        <span>{t('Contrast')}</span>
      </SlidersLabels>

      <ContrastSliderTextWrapper colorContrast={colorContrast}>
        <ContrastSliderText>{colorContrastValue}</ContrastSliderText>
      </ContrastSliderTextWrapper>
    </ContrastSliderWrapper>
  )
}
